import React from "react";
import useSharedStyles from "../sharedStyles";

const StatusPill = ({ config }) => {
  const { classes } = useSharedStyles();
  if (!config) return null;
  return (
    <span
      className={classes.pill}
      style={{
        background: config.bg,
        color: config.color,
        borderColor: config.border,
      }}
    >
      {config.label}
    </span>
  );
};

export default StatusPill;
